import { useEffect, useState, useCallback } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ProgressBoard from "@/components/ProgressBoard";
import MatchChallenge from "@/components/MatchChallenge";
import DonationWidget from "@/components/DonationWidget";
import Story from "@/components/Story";
import Gallery from "@/components/Gallery";
import BelieveCards from "@/components/BelieveCards";
import Allocations from "@/components/Allocations";
import DonorWall from "@/components/DonorWall";
import ShareBar from "@/components/ShareBar";
import Footer from "@/components/Footer";
import { fetchStats, fetchDonors } from "@/lib/api";

export default function Landing() {
  const [stats, setStats] = useState({
    total_raised: 0,
    goal: 10000,
    supporters: 0,
    remaining: 10000,
    percentage: 0,
  });
  const [donors, setDonors] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const [s, d] = await Promise.all([fetchStats(), fetchDonors(50)]);
      setStats(s);
      setDonors(d);
    } catch (e) {
      console.error("Failed to load stats/donors", e);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <div data-testid="landing-page" className="relative min-h-screen bg-[#09090B] text-white">
      <Header stats={stats} />
      <Hero />
      <ProgressBoard stats={stats} />
      <MatchChallenge stats={stats} />
      <section id="donate" className="relative scroll-mt-24">
        <DonationWidget onSuccessRefresh={refresh} />
      </section>
      <Story />
      <Gallery />
      <BelieveCards />
      <Allocations />
      <DonorWall donors={donors} />
      <ShareBar />
      <Footer />
    </div>
  );
}
